import '../../scss/acf-blocks/acfb-main-hero.scss';

/**
 * Main hero: pulsante play/pausa per il video di sfondo in autoplay.
 *
 * WCAG 2.2.2 (Pause, Stop, Hide): un contenuto in movimento che parte da solo
 * e dura più di 5 secondi deve poter essere fermato dall'utente. Il pulsante
 * è nel markup con l'attributo hidden e viene mostrato solo qui, così senza JS
 * non resta un controllo che non fa nulla.
 */
document.addEventListener( 'DOMContentLoaded', () => {

	document.querySelectorAll( '.main-hero--has-video' ).forEach( ( hero ) => {
		const video  = hero.querySelector( 'video.main-hero__media' );
		const button = hero.querySelector( '.main-hero__video-toggle' );

		if ( ! video || ! button ) {
			return;
		}

		const labelPause = button.dataset.labelPause;
		const labelPlay  = button.dataset.labelPlay;

		// Lo stato segue gli eventi del video, non il click: copre anche
		// l'autoplay bloccato dal browser (il video resta fermo e il pulsante
		// mostra "Riproduci").
		function syncState() {
			const paused = video.paused;
			button.classList.toggle( 'is-paused', paused );
			button.setAttribute( 'aria-label', paused ? labelPlay : labelPause );
		}

		button.addEventListener( 'click', () => {
			if ( video.paused ) {
				const playPromise = video.play();
				if ( playPromise && typeof playPromise.catch === 'function' ) {
					playPromise.catch( syncState );
				}
			} else {
				video.pause();
			}
		} );

		video.addEventListener( 'play', syncState );
		video.addEventListener( 'pause', syncState );

		syncState();
		button.hidden = false;
	} );

} );
